module.exports = __webpack_public_path__ + "static/poster_sp_jp-60214c719d196f7fb32161d22d97ca2d.png";